import React, { Component } from 'react';

export default class Head extends Component {
	state = {on:true}
	componentDidMount() {
		this.updateValue()
		this.updateValue = this.updateValue.bind(this)
	}
	updateValue() {
		global.setAnswer("backUpGoogleDrive", this.state.on)
	}
	render() {
		return <div style={{}}>
			<div style={{
				position:"absolute",
				left: 0,
				top: 0,
				width:360,
				height:20,
				backgroundColor:global.blue
			}}/>
			<img src={require('./img/gBackup.png')} style={{
				position:"absolute",
				left: 10,
				top: 75,
				width:359,
				height:371
			}} />
			<img src={this.state.on ? require('./img/rOn.png'): require('./img/rOff.png')} 
					onClick={() => this.setState({on:!this.state.on}, this.updateValue)}
					style={{
						position:"absolute",
						top:330,
						right:20,
						cursor:"pointer",
						width:45,
						height:45,
						alignSelf:"center"	

					}}
			/>
			<div style={{
				position:"absolute",
				right: 30,
				bottom: 40,
				width:90,
				height:40,
				backgroundColor:global.blue,
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				cursor:"pointer"
			}} onClick={global.nextStage}>
				<span style={{
					color:"white"	
				}}>AGREE</span>
			</div>
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Google_backup.js